const scoring = {
    initTrips: [
        {
            _id: 0,
            slowdown: [false, false, false],
            correctStop: [false, false, false],
            cbNotDistraction: [true, true, true],
            radioNotDistraction: [true, true, true],
            windowsDown: [false, false, false],
            lookedBothWays: [false, false, false],
            movedForward: [false, false, false],
            storageSpace: true,
            noPhone: true
        },
        {
            _id: 1,
            slowdown: [false, false],
            correctStop: [false, false],
            cbNotDistraction: [true, true],
            radioNotDistraction: [true, true],
            windowsDown: [false, false],
            lookedBothWays: [false, false],
            movedForward: [false, false],
            followedCorrectPath: true,
            noPhone: true,
            followedFlagger: false,
            turnedOnHazards: [false, false]
        },
        {
            _id: 2,
            slowdown: [true, false, false],
            correctStop: [false, false, false],
            cbNotDistraction: [true, true, true],
            radioNotDistraction: [true, true, true],
            windowsDown: [false, false, false],
            lookedBothWays: [false, false, false],
            movedForward: [false, false, false],
            noGPS: true,
            noPhone: true
        },
    ],

    trips: [
        {
            _id: 0,
            slowdown: [false, false, false],
            correctStop: [false, false, false],
            cbNotDistraction: [true, true, true],
            radioNotDistraction: [true, true, true],
            windowsDown: [false, false, false],
            lookedBothWays: [false, false, false],
            movedForward: [false, false, false],
            storageSpace: true,
            noPhone: true
        },
        {
            _id: 1,
            slowdown: [false, false],
            correctStop: [false, false],
            cbNotDistraction: [true, true],
            radioNotDistraction: [true, true],
            windowsDown: [false, false],
            lookedBothWays: [false, false],
            movedForward: [false, false],
            followedCorrectPath: true,
            noPhone: true,
            followedFlagger: false,
            turnedOnHazards: [false, false]
        },
        {
            _id: 2,
            slowdown: [true, false, false],
            correctStop: [false, false, false],
            cbNotDistraction: [true, true, true],
            radioNotDistraction: [true, true, true],
            windowsDown: [false, false, false],
            lookedBothWays: [false, false, false],
            movedForward: [false, false, false],
            noGPS: true,
            noPhone: true
        },
    ],
    // each trip, we'll populate this with hydrateTempTrip()
    tempTrip: {},
    routesCompleted: {
        west: false,
        pacific: false, 
        southwest: false,
        midwest: false
    },
    currentRoute: null,
    currentTrip: -1,
    initializeTrip(routeId, tripId) {
        this.setCurrentTrip(tripId);
        this.setCurrentRoute(routeId)
        this.hydrateTempTrip(tripId)
        console.log(this)
    },
    hydrateTempTrip(tripId) {
        this.tempTrip = Object.assign({}, this.trips[tripId]);
        console.log("this.trips[tripId]" , this.trips[tripId]);
    },
    getCurrentRoute() {
        return this.currentRoute
    },
    setCurrentRoute(id) {
        this.currentRoute = id;
    },
    setCurrentTrip(id) {
        this.currentTrip = id;
    },
    clearTempTrip() {
        this.tempTrip = {};
    },
    setRouteComplete(route) {
        // commented out the errors so Robin can QA
        if (route === undefined) {
            //throw new Error('no route defined in setRoute method of scoring.js')
        }
        if (this.routesCompleted[route] === undefined) {
            // throw new Error(`incorrect route ${route} passed to setRoute method of scoring.js`)
        }
        console.log("setRouteComplete this.routesCompleted" ,this.routesCompleted[route]);
        this.routesCompleted[route] = true;
    },
    tearDownTrip() {
        this.setRouteComplete(this.getCurrentRoute());
        this.setCurrentRoute(null);
        this.setCurrentTrip(-1);
        this.clearTempTrip();
        console.log(this)
    },
    setMultiple(actions, tripId, arrayId) {
        if (!Array.isArray(actions)) {
            throw new Error(`scoring.setMultiple must be passed an array of actions as first arg. Was passed ${actions}`);
        }
        try {
            actions.forEach(action => {
                this.setScore(action, tripId, arrayId, true)
            })
        } catch (e) {
            throw new Error(`scoring.setMultiple received error from scoring.setScore -\n${e.stack}`)
        }
    },
    setScore(action, tripId, crossingId, isTrue = true) {
        // action = property to set, arrayId is usually the crossingId (some exceptions)
        if (!(tripId > -1 && tripId < this.trips.length)) {
            throw new Error(`scoring setter passed incorrect tripId: ${tripId}`);
        }
        if (this.trips[tripId][action] === undefined) {
            throw new Error(`scoring setter passed incorrect action: ${action}`);
        }
        // if no crossingId is passed, we are not working with an array
        // and just need to switch the boolean of the relevant proeprty to true    
        
        console.log("scoring setScore action" , action);
        console.log("scoring setScore tripId" , tripId);
        console.log("scoring setScore crossingId" , crossingId);
        console.log("this.trips[tripId][action][crossingId]" , this.trips[tripId][action][crossingId]);

        console.log("this.getCurrentRoute()" , this.getCurrentRoute());
        console.log("this.routesCompleted[route]" , this.routesCompleted[this.getCurrentRoute()]);
          
        if (crossingId === undefined || crossingId === null) {
            this.tempTrip[action] = isTrue;
        } else if (this.trips[tripId][action][crossingId] !== undefined) {            
            this.tempTrip[action][crossingId] = isTrue;
        } else {
            this.tempTrip[action] = isTrue;
            // throw new Error(`scoring setter passed incorrect crossingId: ${crossingId}`)
        }  
        console.log("this.tempTrip[action]" , this.tempTrip[action]);     
    },
    setPhoneFalse(tripId) {
        if (!(tripId > -1 && tripId < this.trips.length)) {
            throw new Error(`scoring setter passed incorrect tripId: ${tripId}`);
        }
        this.tempTrip.noPhone = false;
    },
    getScore(tripId) {
        const scoreArray = this.getScoreArray(this.tempTrip);
        const score = Math.floor((scoreArray.filter(e => e).length / scoreArray.length)*100)
        return !isNaN(score) ? score : 0
    },
    resetCrossingScore(tripId, crossingId) {
        for (const[key,value] of Object.entries(this.initTrips[tripId])) {
            if (value[crossingId] !== undefined ) {
                this.trips[tripId][key][crossingId] = value[crossingId]
                if (this.tempTrip._id === tripId) {
                    this.tempTrip[key][crossingId] = value[crossingId]
                }
            }
        }
    },
    getTripScore(tripId) {
        const scoreArray0 = this.getScoreArray(this.trips[tripId]);
        // console.log(scoreArray0);
        // console.log("len1::::"+scoreArray0.filter(e => e).length);
        // console.log("len2::::"+scoreArray0.length);
        // console.log("get the score::"+Math.floor((scoreArray0.filter(e => e).length / scoreArray0.length)*100));
        return Math.floor((scoreArray0.filter(e => e).length / scoreArray0.length)*100)
    },

    saveScore(tripId) {
        if (this.tempTrip._id !== undefined){
            this.trips[tripId] = Object.assign({}, this.tempTrip);
        }
    },
    getTotalTripScore(tripNum) {
        const scoreArray0 = this.getScoreArray(this.trips[0]);
        const scoreArray1 = this.getScoreArray(this.trips[1]);
        const scoreArray2 = this.getScoreArray(this.trips[2]);          
   
        const totalScoreArrays = [[...scoreArray0], [...scoreArray1], [...scoreArray2]]; 
        console.log("totalScoreArrays" , totalScoreArrays);
        
        let tempTotalArray = totalScoreArrays.map((tripArray,tripIdx) => { 
            let tempTripArray = []
            if(tripNum === tripIdx || (tripIdx === 0 && this.routesCompleted.west) || (tripIdx === 0 && this.routesCompleted.pacific) || (tripIdx === 1 && this.routesCompleted.southwest) ||  (tripIdx === 2 && this.routesCompleted.midwest)){
                tempTripArray = tripArray.map((actionComplete,actionIdx) => {                    
                    return actionComplete
                })
            } else{
                tempTripArray = tripArray.map((actionComplete,actionIdx) => { 
                    return false
                })
            } 
            return tempTripArray
        }) 
         // Set a score per each crossing with the following values
        // Crossings 1 & 2 will have a max value of 33% and crossing 3 34%
        const scoreC1 = Math.floor((tempTotalArray[0].filter(e => e).length / tempTotalArray[0].length)*100)
        const scoreC2 = Math.floor((tempTotalArray[1].filter(e => e).length / tempTotalArray[1].length)*100)
        const scoreC3 = Math.floor((tempTotalArray[2].filter(e => e).length / tempTotalArray[2].length)*100)
        const newScore = Math.floor(
            (scoreC1 * .33) +
            (scoreC2 * .33) +
            (scoreC3 * .34)
        );
        console.log('Score per crossing', scoreC1, scoreC2, scoreC3, newScore)
        return newScore;
        const totalScoreArray = [...tempTotalArray[0], ...tempTotalArray[1], ...tempTotalArray[2]];         
        console.log("totalScoreArray" , totalScoreArray);
        console.log("totalScoreArray.filter(e => e).length" , totalScoreArray.filter(e => e).length);  
        console.log("totalScoreArray.length" , totalScoreArray.length);  
        const score = Math.floor((totalScoreArray.filter(e => e).length / totalScoreArray.length)*100)
        console.log("getTotalScore score" , score);
        return score
    },
    getTotalScore() {
        const scoreArray0 = this.getScoreArray(this.trips[0]);
        const scoreArray1 = this.getScoreArray(this.trips[1]);
        const scoreArray2 = this.getScoreArray(this.trips[2]);
        // Set a score per each crossing with the following values
        // Crossings 1 & 2 will have a max value of 33% and crossing 3 34%
        const scoreC1 = Math.floor((scoreArray0.filter(e => e).length / scoreArray0.length)*100)
        const scoreC2 = Math.floor((scoreArray1.filter(e => e).length / scoreArray1.length)*100)
        const scoreC3 = Math.floor((scoreArray2.filter(e => e).length / scoreArray2.length)*100)
        const newScore = Math.floor(
            (scoreC1 * .33) +
            (scoreC2 * .33) +
            (scoreC3 * .34)
        );
        console.log('Score per crossing', scoreC1, scoreC2, scoreC3, newScore)
        return newScore;

        const totalScoreArray = [...scoreArray0, ...scoreArray1, ...scoreArray2];   
        console.log("totalScoreArray.filter(e => e).length" , totalScoreArray.filter(e => e).length);  
        console.log("totalScoreArray.length" , totalScoreArray.length);  
        const score = Math.floor((totalScoreArray.filter(e => e).length / totalScoreArray.length)*100)
        console.log("getTotalScore score" , score);
        return score
    },
    getScoreArray(tripScoreObject) {
        return Object.keys(tripScoreObject).reduce((accum, cur) => {
            console.log("cur" , cur);
            console.log("tripScoreObject[cur]" , tripScoreObject[cur]);
            const associatedValue = tripScoreObject[cur];
            // trip IDs aren't part of the score
            if (cur === '_id') return accum
            if (!Array.isArray(associatedValue)) {
                accum.push(associatedValue);
            } else {
                associatedValue.forEach(e => accum.push(e));
            }
            return accum
        }, [])
    },
    getChecklistArray(tripId) {
        //maps score objects to binary array which is mapped to the checklist jsx element
        const scoreObject = this.trips[tripId]; 
        console.log("scoreObject" , scoreObject);     
        const checklistArray = Object.keys(scoreObject).map((e, i) => {            
            const associatedValue = scoreObject[e];  
            if (Array.isArray(associatedValue)) {               
                return associatedValue.every(e => e)
            } else {               
                return associatedValue
            }
            
        })
        return checklistArray.slice(1)
    }
}

export default scoring